export function Card({ children, className = "" }) {
    return (
      <div className={`bg-white shadow-md rounded-xl p-4 ${className}`}>
        {children}
      </div>
    );
  }
  
  export function CardContent({ children, className = "" }) {
    return <div className={className}>{children}</div>;
  }
  // components/card.jsx
export function CardFooter({ children }) {
    return <div className="px-6 py-4 border-t mt-auto">{children}</div>;
  }
  